var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRibbonGrayHorBottom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1599,
    height: 526,
    viewBox: "0 0 1599 526",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_939_1638",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 1599,
    height: 526
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1599,
    height: 526,
    fill: "#6629D7"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_939_1638)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-46.4746 217.126C145.246 320.871 483.747 318.933 536.348 118.908C582.506 -56.6196 291.826 -97.2986 330.044 136.344C368.262 369.987 1046.93 720.679 1611.31 321.696",
    stroke: "#E2E2E2",
    strokeOpacity: 0.3,
    strokeWidth: 15,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonGrayHorBottom);
export default __webpack_public_path__ + "static/media/ribbon-gray-hor-bottom.ba995844eee621495537bfa8d1f27790.svg";
export { ForwardRef as ReactComponent };